import { BodyContainer, FooterContainer } from "../ContentPageGrid";
import HeaderBanner from "./header/HeaderBanner";
import Content from "./Content";
import Footer from "../../components/footer/Footer";
import styled from "@emotion/styled";
import { spacing } from "@atlas-int/tokens";
import InfoBanner from "../../components/InfoBanner";
import { useLocation } from "react-router";
import { useEffect } from "react";
import { usePageTracking } from "../../sharedUtilities/analytics";

const LandingPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;

`;

const LandingPageBodyContainer = styled(BodyContainer)`
  padding: ${spacing[0]};
`;

const ContentPage = () => {
  // Track page views on route changes
  usePageTracking();

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <>
      <InfoBanner />
      <LandingPageContainer>
        <HeaderBanner />
        <LandingPageBodyContainer>
          <Content />
        </LandingPageBodyContainer>
        <FooterContainer>
          <Footer />
        </FooterContainer>
      </LandingPageContainer>
    </>
  );
};

export default ContentPage;
